import { ResourceType } from './subcontractTypes';

/**
 * Fila del Calendario de Subcontratos tal como la devuelve el backend.
 * El código CIP ya viene con el sufijo de subcontrato aplicado.
 */
export interface SubcontractCalendarEntry {
    rut: string;
    businessName: string;
    resourceType: ResourceType;
    /** CIP ya transformado por el backend. */
    cip: string;
    nameActivity: string;
    sectionActivity: string;
    headcount: number;
    totalHours: number;
    /** Fecha en formato ISO, por ejemplo 2026-07-27T00:00:00. */
    activityDate: string;
}

/** Identifica una fila de la matriz: una empresa para un tipo de recurso. */
export interface SubcontractCalendarRow {
    key: string;
    rut: string;
    businessName: string;
    resourceType: ResourceType;
    /**
     * true solo en la primera fila de cada empresa.
     *
     * En Modo Mixto el nombre y el RUT aparecen una sola vez y la fila siguiente del mismo
     * subcontratista los deja en blanco, según la sección 5.2. Ojo: en la exportación a
     * Excel ocurre lo contrario, ahí se repiten en ambas filas de forma obligatoria para
     * que los filtros de la planilla funcionen (sección 5.3.1).
     */
    showIdentity: boolean;
}

/** Rótulo en español del tipo de recurso, usado en la columna "Tipo" y en el Excel. */
export const resourceTypeLabel = (resourceType: ResourceType): string =>
    resourceType === 'PERSONNEL' ? 'Personal' : 'Equipos';
